export class StorageService {
  public static setItem(storageType: string, key: string, value: any) {
    switch (storageType) {
      case 'local':
        localStorage.setItem(key, value);
        break;
      case 'session':
        sessionStorage.setItem(key, value);
        break;
      /*    case enumStorageType.Cookie.toString():
       setCookie(key, value);
        break; */
    }
  }

  public static getItem(storageType: string, key: string): any {
    switch (storageType) {
      case 'local':
        return localStorage.getItem(key);
      case 'session':
        return sessionStorage.getItem(key);
      /*   case enumStorageType.Cookie.toString():
      const val = getCookie(key);
       if (val === undefined) return null; */
    }
  }

  public static removeItem(storageType: string, key: string): any {
    switch (storageType) {
      case 'local':
        localStorage.removeItem(key);
      case 'session':
        sessionStorage.removeItem(key);
      /*  case enumStorageType.Cookie.toString():
      removeCookie(key);
        break; */
    }
    return null;
  }
}
export default StorageService;
